import { createFileRoute, redirect } from '@tanstack/react-router';
export const Route = createFileRoute('/_staff/settings/authentication/')({
  beforeLoad() {
    throw redirect({
      to: '/settings/authentication/access-rules'
    });
  }
});